import useUserVarStore from "@app/store/useUserVarStore";
import registeredUser from "@assets/header/menu-selected/icon/registered-user-new.svg";
import NDRIcon from "@assets/ndr2025/ndr-title-icon.gif";
import BudgetPDFBanner from "@components/Blocks/BudgetPDFBanner/BudgetPDFBanner";
import AdsContainer from "@components/Blocks/Container/AdsContainer";
import HorizontalStoryPackage from "@components/Layouts/HomePageStoryPackages/HorizontalStoryPackage";
import PodcastPackage from "@components/Layouts/HomePageStoryPackages/MediaPackages/PodcastPackage";
import VideoPackage from "@components/Layouts/HomePageStoryPackages/MediaPackages/VideoPackage";
import MyBHStoryPackage from "@components/Layouts/HomePageStoryPackages/MyBHStoryPackage";
import VerticalStoryPackage from "@components/Layouts/HomePageStoryPackages/VerticalStoryPackage";
import { ENABLE_BUDGET_PDF_BANNER } from "@config/budgetPDF";
import { ENABLE_MYBH } from "@config/followTopic";
import { ENABLE_KAKI_MAKAN } from "@config/kakiMakan";
import { NDR_2025_PAGE } from "@config/ndr2025";
import { PodcastBHCustomEventCategory } from "@config/podcastEvent";
import { AdsImu1 } from "@elements/Advertisement/variant/AdsImu";
import { AdsLb2 } from "@elements/Advertisement/variant/AdsLb";
import { NDR_FEATURE_ENABLE } from "@helper/getEnvVariables";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import { CasBannerWidget } from "@routes/Home/Components/CasBannerWidget";
import TrendingTopics, {
  TrendingTopicItem,
} from "@routes/Home/Components/TrendingTopics";
import useRecommendedArticles from "@src/app/hooks/useRecommendedArticles";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";

import WidgetWrapper from "./WidgetWrapper";

export type HomePageNewProps = {
  topStoryQueue: ProcessedArticleData[];
  latestFreeArticle: ProcessedArticleData[];
  latestSgArticle: ProcessedArticleData[];
  latestMaArticle: ProcessedArticleData[];
  kakiJalanArticle: ProcessedArticleData[];
  kakiMakanArticle: ProcessedArticleData[];
  dnaDuniaArticle: ProcessedArticleData[];
  latestGayaArticle: ProcessedArticleData[];
  registeredArticle: ProcessedArticleData[];
  latestDuniaArticle: ProcessedArticleData[];
  adsSectionName: string;
  pageAdTargetValue: PageAdTargetingTypeEnum;
  ndrArticle?: ProcessedArticleData[];
  UGCBanner?: string;
  KakiMakanBanner?: string;
  myBHServerArticles?: ProcessedArticleData[];
  trendingTopics?: TrendingTopicItem[];
};
export default function HomePageNew({
  topStoryQueue,
  latestFreeArticle,
  ndrArticle,
  latestSgArticle,
  latestMaArticle,
  kakiJalanArticle,
  kakiMakanArticle,
  dnaDuniaArticle,
  latestGayaArticle,
  registeredArticle,
  latestDuniaArticle,
  adsSectionName,
  pageAdTargetValue,
  UGCBanner,
  KakiMakanBanner,
  myBHServerArticles,
  trendingTopics = [],
}: HomePageNewProps) {
  const isMyBHEnabled = ENABLE_MYBH;
  const { userToken, deviceId } = useUserVarStore();
  const { articles: myBHArticles } = useRecommendedArticles({
    userToken,
    deviceId,
    page: 1,
    size: 4,
    enabled: isMyBHEnabled,
    initialArticles: myBHServerArticles,
  });

  return (
    <>
      <WidgetWrapper>
        <VerticalStoryPackage
          firstCardVariant="featured"
          restCardVariant="2md"
          renderItems={topStoryQueue}
          styles={{
            wrapperStyle: "border-t-0",
          }}
        />
        {ENABLE_BUDGET_PDF_BANNER && <BudgetPDFBanner />}
      </WidgetWrapper>
      <AdsContainer>
        <AdsLb2
          uniqueSectionName={adsSectionName}
          pageAdTargetType={pageAdTargetValue}
          hasStripeBg={false}
        />
      </AdsContainer>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="featured"
          renderItems={latestFreeArticle}
          styles={{
            wrapperStyle: "border-t-0",
            cardWrapperStyle: "pb-0",
            cardInnerWrapperStyle:
              "flex-col md:grid md:grid-cols-2  xl:flex xl:flex-row gap-[20px] w-full",
            imageWidth: 284,
            imageHeight: 195,
          }}
        />
        {ENABLE_KAKI_MAKAN && (
          <CasBannerWidget CasBannerWidgetContent={KakiMakanBanner} />
        )}
      </WidgetWrapper>
      {ndrArticle && parseInt(NDR_FEATURE_ENABLE) && (
        <WidgetWrapper>
          <VerticalStoryPackage
            firstCardVariant="small"
            restCardVariant="large"
            renderItems={ndrArticle}
            title="Hari Kebangsaan 2025"
            moreLink={{
              destination: `${NDR_2025_PAGE}?ref=home`,
            }}
            styles={{
              wrapperStyle: "border-red-100",
              titleStyle: "text-[#FA2455] flex gap-xs items-center pl-xxs",
            }}
            titleIcon={{
              src: NDRIcon,
              width: 40,
              height: 40,
            }}
          />
        </WidgetWrapper>
      )}
      {isMyBHEnabled && (
        <WidgetWrapper>
          <MyBHStoryPackage articles={myBHArticles} />
        </WidgetWrapper>
      )}
      <WidgetWrapper>
        <VerticalStoryPackage
          firstCardVariant="small"
          restCardVariant="large"
          renderItems={latestSgArticle}
          title="Singapura"
          moreLink={{
            destination: "singapura",
          }}
          styles={{
            wrapperStyle: "border-red-100",
            titleStyle: "text-red-100",
          }}
        />
      </WidgetWrapper>
      <AdsContainer>
        <AdsLb2
          uniqueSectionName={adsSectionName}
          pageAdTargetType={pageAdTargetValue}
          hasStripeBg={false}
          index={1}
        />
      </AdsContainer>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="large"
          renderItems={latestMaArticle}
          title="Malaysia"
          moreLink={{
            destination: "malaysia",
          }}
          styles={{
            wrapperStyle: "border-pink-600",
            titleStyle: "text-pink-600",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="small"
          renderItems={kakiJalanArticle}
          title="Kaki Jalan"
          moreLink={{
            destination: "tags/kaki-jalan",
          }}
          styles={{
            wrapperStyle: "border-blue-400",
            titleStyle: "text-blue-400",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <CasBannerWidget CasBannerWidgetContent={UGCBanner} />
      </WidgetWrapper>
      <WidgetWrapper>
        <div className="flex flex-col lg:flex-row gap-xs">
          <div className="w-full lg:max-w-[645px] xl:max-w-[860px]">
            <HorizontalStoryPackage
              variant="small"
              renderItems={kakiMakanArticle}
              title="Kaki Makan"
              moreLink={{
                destination: "tags/kaki-makan",
              }}
              styles={{
                wrapperStyle: "border-blue-400",
                titleStyle: "text-blue-400",
              }}
            />
          </div>
          <AdsContainer className="flex w-full lg:max-w-[320px] justify-center items-center bg-white-100">
            <AdsImu1
              uniqueSectionName={adsSectionName}
              pageAdTargetType={pageAdTargetValue}
            />
          </AdsContainer>
        </div>
      </WidgetWrapper>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="small"
          renderItems={dnaDuniaArticle}
          title="DNA Dunia Anak"
          moreLink={{
            destination: "tags/dna-dunia-anak",
          }}
          styles={{
            wrapperStyle: "border-blue-350",
            titleStyle: "text-blue-350",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <VerticalStoryPackage
          firstCardVariant="small"
          restCardVariant="large"
          renderItems={latestGayaArticle}
          title="Gaya Hidup"
          moreLink={{
            destination: "gaya-hidup",
          }}
          styles={{
            wrapperStyle: "border-red-600",
            titleStyle: "text-red-600",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="medium"
          renderItems={registeredArticle}
          title="Pengguna Berdaftar"
          moreLink={{
            destination: "registered",
          }}
          styles={{
            wrapperStyle: "border-purple-300",
            titleStyle: "flex gap-xs items-center text-purple-300 pl-xxs",
          }}
          titleIcon={{
            src: registeredUser,
            width: 16,
            height: 16,
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <HorizontalStoryPackage
          variant="large"
          renderItems={latestDuniaArticle}
          title="Dunia"
          moreLink={{
            destination: "dunia",
          }}
          styles={{
            wrapperStyle: "border-pink-600",
            titleStyle: "text-pink-600",
          }}
        />
      </WidgetWrapper>
      <WidgetWrapper>
        <PodcastPackage
          bhCustomEventProps={{
            eventCategory: PodcastBHCustomEventCategory.HOME_PAGE,
            eventAction: "click",
          }}
        />
        <VideoPackage />
      </WidgetWrapper>
      <WidgetWrapper>
        <TrendingTopics topics={trendingTopics} />
      </WidgetWrapper>
    </>
  );
}
